export default __webpack_public_path__ + "static/media/loyola7.b19e1ae6.jpg";